
//系统目录 / 卫材 接口相关的函数
import request from "@/untils/request.js"

/**
 * 
 *  post
 *  
 */

// 卫材 = > 分页
export const eisaiList = (data) => {
    return request.post("/outpatient/eisai/page", data )
}

// 生产厂商 = > 分页
export const productionList = (params) => {
    return request.get("/outpatient/getManufacturer", {params} )
}

// 用于新建生产厂商
export const addProduction = (data) => {
    return request.post("/outpatient/addManufacturer", data )
}

// 修改生产厂商
export const updateProduction = (data) => {
    return request.post("/outpatient/editManufacturer", data )
}

// 生产厂商 = > 详情
export const getProduction = (params) => {
    return request.get("/outpatient/getManufacturerById", {params} )
}

// 用于新建卫材
export const addEisai = (data) => {
    return request.post("/outpatient/eisai/add", data )
}

// 修改卫材
export const updateEisai = (data) => {
    return request.post("/outpatient/eisai/edit", data )
}


/**
 * 
 * get 
 *  
 */

// 卫材种类列表
export const eisaiType = (params) => {
    return request.get("/outpatient/eisai/type", { params })
}

// 查看卫材种类列表
export const detailEisai = (params) => {
    return request.get("/outpatient/eisai/detail", { params })
}

// 删除单条卫材项目
export const deleteEisai = (params) => {
    return request.delet("/outpatient/eisai/delete", { params })
}



/*
 * 
 * DELETE 
 *   
 */   


// 暴露
export default{
	eisaiList,
	addEisai,
	updateEisai,
	eisaiType,
	addProduction,
	detailEisai,
	deleteEisai
}